import { takeEveryFsa } from "../operations";
import { appActions } from "./actions";
import { put } from "typed-redux-saga";

export function* appSaga() {
  yield takeEveryFsa(appActions.showModal.started, function* (action) {
    yield* put(
      appActions.showModal.done({
        params: action.payload,
        result: {},
      })
    );
  });
}
